import { render, staticRenderFns } from "./MixAndMatchPricing.vue?vue&type=template&id=3613f315&scoped=true"
import script from "./MixAndMatchPricing.vue?vue&type=script&lang=js"
export * from "./MixAndMatchPricing.vue?vue&type=script&lang=js"
import style0 from "./MixAndMatchPricing.vue?vue&type=style&index=0&id=3613f315&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3613f315",
  null
  
)

export default component.exports